<template>
  <div class="hot">
    <div class="title"></div>
    <div class="list">
      <ul>
        <li v-for="(item, index) in cList" :key="index">
          <a href="###">
            <i>{{ index + 1 }}</i>
            <span class="hotPoint" @click="searchHot(item.name)">{{
              item.name
            }}</span>
            <span style="float: right">{{ item.value }}</span>
          </a>
          <div class="clear"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-silder-hot",
  components: {},
  props: {
    cList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    // searchRank(item) {
    //   // this.$emit("func", item);
    //   console.log(this);
    // },
    searchHot(item) {
      this.$emit("func", item);
    },
  },
  created() {
    // console.log(this.cList);
  },
  mounted() {},
};
</script>

<style lang='less' scoped>
.fl {
  float: left;
}
.clear {
  clear: both;
}
.hot {
  width: 100%;
  // width:365px;
  max-height: 360px;
  margin-bottom: 40px;

  .title {
    width: 56px;
    height: 19px;
    font-size: 18px;
    font-weight: bold;
    background-image: url("../../assets/img/hot_title.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-bottom: 20px;
    // border-bottom: 1px solid rgb(230, 230, 230);
  }
  .list {
    width: 100%;
    // width:365px;
    ul {
      margin: 0;
      padding: 0;
      li {
        height: 24px;
        // width: 323px;
        width:100%;
        margin-top: 10px;
        a {
          text-decoration: none;
          color: black;
          .hotPoint {
            display: inline-block;
            width: 230px;
            height: 17px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        i {
          display: inline-block;
          width: 18px;
          height: 21px;
          margin-right: 12px;
          color: #ffffff;
          // background-color: rgb(204, 204, 204);
          font-size: 12px;
          text-align: center;
          line-height: 21px;
          background-image: url("../../assets/img/hot_normal.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          position: relative;
          top: -3px;
        }
        span {
          line-height: 17px;
        }
      }
      li:nth-child(1) {
        i {
          background-image: url("../../assets/img/hot_first.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
      li:nth-child(2) {
        i {
          background-image: url("../../assets/img/hot_second.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
      li:nth-child(3) {
        i {
          background-image: url("../../assets/img/hot_third.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
    }
  }
}
</style>